export default __webpack_public_path__ + "static/media/viktor-forgacs.6b546b32.jpg";